import { IProjectileContainer } from "../IProjectileContainer";
import { IdleTimeoutState } from "./states/IdleTimeoutState";
import { DigOutState } from "./states/DigOutState";
import { DigInState } from "./states/DigInState";
import { DieState } from "./states/DieState";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { AudioController } from "../../../AudioController";
import { EatingState } from "./states/EatingState";
import { FreezeState } from "./states/FreezeState";
import { BaseMole } from "./BaseMole";
import { Vegetable } from "../Vegetable";
import { HatType } from "../../../../models/data/HatType";
import { Character } from "../../character/Character";
import { BatchedRenderer } from "three.quarks";
import { GameController } from "../../../../controllers/GameController";
import { IMoleState } from "./states/IMoleState";
import { IdleToRepeatState } from "./states/IdleToRepeatState";

export class EatingMole extends BaseMole {
    public constructor(
        gameResources: GameResourcesPackage,
        projectileContainer: IProjectileContainer,
        particlesRenderer: BatchedRenderer,
        character: Character,
        vegetable: Vegetable,
        audioController: AudioController,
        gameController: GameController,
        fieldIndex: number
    ) {
        super(
            fieldIndex,
            gameResources,
            projectileContainer,
            particlesRenderer,
            character,
            audioController,
            gameController
        );

        const dieState = new DieState(this, this.animationController);
        const freezeState = new FreezeState(gameResources, particlesRenderer, this, this.animationController, dieState);
        const digInState = new DigInState(this, this.animationController, dieState, freezeState);
        const idleAfterAttackState = new IdleToRepeatState(this, this.animationController, dieState, freezeState, this.randomIdleAnimationTimeout());
        const attackState: IMoleState = new EatingState(this, this.animationController, idleAfterAttackState, digInState, dieState, freezeState, vegetable, audioController);
        const idleBeforeAttackState = new IdleTimeoutState(this, this.animationController, attackState, dieState, freezeState, this.randomIdleAnimationTimeout());
        const digOutState = new DigOutState(this, this.animationController, idleBeforeAttackState, dieState, freezeState);
        this.switchState(digOutState);
    }

    protected override resolveHatType(): HatType {
        return HatType.Cap;
    }
}